/*@ngInject*/
const UserAccessButtonController = function ($scope, $element, $state, userType, userMediator, authorizationConstants, currentUserModel) {

    $element.addClass('userAccessButton');

    this.hasAgencyRole = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_PRODUCERS);
    this.hasUnderwriterRole = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_UNDERWRITERS);
    this.hasUserManagementRole = this.hasAgencyRole || this.hasUnderwriterRole;

    this.navigateUserType = function (userType) {
        let previousUser;

        if (userMediator.hasPreviousUser()) {
            previousUser = userMediator.getPreviousUser();
            $state.go('manageUser.form', {
                userId: previousUser.userId,
                userType: previousUser.userType,
                formId: previousUser.formId
            });
        }
        else {
            $state.go('userList', {userType: userType});
        }
    };

    this.onManageAgencyUsers = function () {
        this.navigateUserType(userType.AGENCY_BROKERAGE);
    };

    this.onManageUnderwriters = function () {
        this.navigateUserType(userType.UNDERWRITER);
    };
};

angular.module('umCore')
    .controller('userAccessButtonController', UserAccessButtonController);
